export const PUBLIC_NAVIGATION = [
  { label: 'Find logistics companies', href: '/hub/' },
  { label: 'How it works', href: '/#how-it-works' },
  { label: 'Pricing', href: '/pricing/' },
];

export const PROVIDER_NAVIGATION = [
  { label: 'Overview', href: '/logistics-providers/' },
  { label: 'Provider pricing', href: '/logistics-providers/pricing/' },
  { label: 'Add your company', href: '/company/onboarding/' },
];

export const QUOTE_URL = '/#contact';
